import React, { useState, useEffect } from 'react'
import { Row, Col, Button } from 'antd'
import { CopyOutlined, CheckOutlined } from '@ant-design/icons'
import { translate } from 'react-i18next'
import { get } from 'lodash'
import moment from 'moment'

const ContentFooter = ({ reservationContent, t }) => {
    const [copyDetail, setCopyDetail] = useState(false)
    const [copyText, setCopyText] = useState('')
    const name = get(reservationContent, '[0]name', '')
    const password = get(reservationContent, '[0]password', '')
    const moderators = get(reservationContent, '[0].moderators', '')
    const detail = get(reservationContent, '[0].detail', '')
    const startDate = moment(get(reservationContent, '[0]start_dt', '')).format('D/MM/YYYY HH:mm')
    const endDate = moment(get(reservationContent, '[0]end_dt', '')).format('D/MM/YYYY HH:mm')
    const text = `${t("reservation_detail.url")}: ${window._env_.vRoomUrl}/${name}
${t("reservation_detail.password")}: ${password}
${t("reservation_detail.date")}: ${startDate}
${t("reservation_detail.time")}: ${endDate}
${t("reservation_detail.moderator")}: ${moderators}
${t("reservation_detail.detail")}: ${detail}`

    const onCopy = async () => {
        setCopyText(text)
        await navigator.clipboard.writeText(text)
        setCopyDetail(true)
    }
    useEffect(() => {
        if (copyText !== text) {
            setCopyDetail(false)
        }
    }, [setCopyDetail, copyText, text])
    return (
        <>
            <Row className="reservation-content-footer">
                <Col span={8} offset={16} style={{ float: 'left' }}>
                    {copyDetail
                        ? <Button className="btn-copy-reservation-success"><CheckOutlined />{t("reservation_button_copy")}</Button>
                        : <Button onClick={onCopy} className="btn-copy-reservation"><CopyOutlined />{t("reservation_button_copy")}</Button>
                    }
                </Col>
            </Row>
        </>
    )
}

export default translate()(ContentFooter)
